/**
 * Community-standards versioning constants — frontend mirror of
 * `Life4Earth.V2.Api/Constants/StandardsConstants.cs`.
 *
 * Both sides MUST stay in sync (same procedure as the EULA):
 *   1. Edit `community-standards.en.md` with the new text.
 *   2. Increment STANDARDS_CURRENT_VERSION here.
 *   3. Increment StandardsConstants.CURRENT_VERSION on the backend (must match).
 *   4. The version gap resurfaces the "Read this: community standards"
 *      Getting-started act, and org-scoped posting re-locks until the user
 *      re-acknowledges (voice-ladder gate, Skip ruling 2026-07-07).
 *
 * Deliberate human-decided version number, not a content hash — cosmetic
 * edits must not trigger re-acknowledgment.
 */
export const STANDARDS_CURRENT_VERSION = 1;

/** Human-readable label shown in the modal header. */
export const STANDARDS_CURRENT_VERSION_LABEL = 'Version 1 (Draft)';
